import { DestroyRef, inject, Injectable, Signal, signal } from '@angular/core';

const MOBILE_BREAKPOINT = '(max-width: 768px)';

/**
 * Service for responsive design viewport detection.
 * Provides reactive signals for viewport-related states like mobile breakpoint.
 */
@Injectable({
  providedIn: 'root',
})
export class ViewportService {
  private readonly destroyRef = inject(DestroyRef);
  private readonly _isMobile = signal(globalThis.matchMedia?.(MOBILE_BREAKPOINT)?.matches ?? false);

  /** Whether the viewport matches mobile breakpoint (max-width: 768px) */
  readonly isMobile: Signal<boolean> = this._isMobile.asReadonly();

  constructor() {
    const mediaQuery = globalThis.matchMedia?.(MOBILE_BREAKPOINT);
    if (mediaQuery) {
      const listener = (event: MediaQueryListEvent): void => {
        this._isMobile.set(event.matches);
      };
      mediaQuery.addEventListener('change', listener);
      this.destroyRef.onDestroy(() => mediaQuery.removeEventListener('change', listener));
    }
  }
}
